"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBSolutionsSlogan", {
  enumerable: true,
  get: function get() {
    return _SVBSolutionsSlogan.default;
  }
});
var _SVBSolutionsSlogan = _interopRequireDefault(require("./src/SVBSolutionsSlogan"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }